var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHlaB581(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.323,
    height: 79.634,
    viewBox: "0 0 74.323 79.634",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_618_70",
    "data-name": "Component 618 \\u2013 70",
    transform: "translate(1.918 1.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29790",
    "data-name": "Group 29790"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M6206.806,2281.35h0q-1.06,0-2.1-.094c-15.128-1.365-23.355-18.564-16.009-31.859l18.105-32.766,18.105,32.766c7.347,13.295-.881,30.494-16.009,31.859Q6207.867,2281.35,6206.806,2281.35Z",
    transform: "translate(-6185.975 -2205.217)",
    fill: "none",
    stroke: "#86b8ee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M6216.251,2307.938a13.052,13.052,0,0,1-10.448-7.1,14.8,14.8,0,0,1,.073-14.137l7.714-13.959",
    transform: "translate(-6196.868 -2239.047)",
    fill: "none",
    stroke: "#86b8ee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M6278.805,2223.471V2204.02h27.82v53.469a13.911,13.911,0,0,1-13.911,13.91h0a13.845,13.845,0,0,1-7.441-2.156",
    transform: "translate(-6241.946 -2197.613)",
    fill: "none",
    stroke: "#86b8ee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_68",
    "data-name": "Line 68",
    x1: 8.15,
    transform: "translate(55.811 22.551)",
    fill: "none",
    stroke: "#86b8ee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_69",
    "data-name": "Line 69",
    x1: 8.15,
    transform: "translate(55.811 34.852)",
    fill: "none",
    stroke: "#86b8ee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_70",
    "data-name": "Line 70",
    x1: 8.15,
    transform: "translate(55.811 47.154)",
    fill: "none",
    stroke: "#86b8ee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_71",
    "data-name": "Line 71",
    x1: 8.15,
    transform: "translate(55.811 59.455)",
    fill: "none",
    stroke: "#86b8ee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_72",
    "data-name": "Line 72",
    x2: 39.774,
    transform: "translate(30.882)",
    fill: "none",
    stroke: "#86b8ee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_73",
    "data-name": "Line 73",
    y2: 21.928,
    transform: "translate(43.559 12.924)",
    fill: "none",
    stroke: "#86b8ee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHlaB581);
export default __webpack_public_path__ + "static/media/hla-b-58-1.fdce8ba4d8a7b273eac9943b9bac2069.svg";
export { ForwardRef as ReactComponent };